import { render } from "./TopLevelPdfViewDetail.vue?vue&type=template&id=5459b281"
import script from "./TopLevelPdfViewDetail.vue?vue&type=script&lang=js"
export * from "./TopLevelPdfViewDetail.vue?vue&type=script&lang=js"

import exportComponent from "F:\\PWAs\\hydra-digital-pwa\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__